import React from "react";
const CalendarYealryPopupDesk = (props) => {
    var _a;
    const currentYear = new Date(new Date().getFullYear(), 3, 1) > new Date()
        ? new Date().getFullYear() - 1
        : new Date().getFullYear();
    const setFinYear = (year, index) => {
        props.setOpenYear(false);
        if (props === null || props === void 0 ? void 0 : props.openCalendar)
            props.setOpenCalendar(false);
        props.setFinYear(currentYear - index);
        props.setCurrYear(year.slice(5, year.length).replace("-", ""));
    };
    return (React.createElement("div", { ref: props.parentRef }, props.openYear && (React.createElement("div", { className: `year_container  ${props === null || props === void 0 ? void 0 : props.extenalClassName} ${props.years == null ? "border-0" : ""}` }, (_a = props.years) === null || _a === void 0 ? void 0 : _a.map((year, index) => {
        return (React.createElement("div", { className: "financial_year", key: index },
            React.createElement("span", { onClick: () => setFinYear(year, index) }, year)));
    })))));
};
export const CalendarYealryPopupMob = (props) => {
    const [newSelectedYear, setNewSelectedYear] = React.useState(new Date().getFullYear().toString());
    const [selectedYear, setSelectedYear] = React.useState();
    return (React.createElement("div", null,
        React.createElement("div", { className: "year_list" },
            props.years.map((year, index) => {
                return (React.createElement("div", { className: "financial_year" },
                    React.createElement("span", { onClick: () => {
                            setSelectedYear(index);
                            setNewSelectedYear(year);
                        }, className: selectedYear === index ||
                            (selectedYear === undefined &&
                                props.finYear == year.slice(3, 7))
                            ? "color_blue"
                            : "", key: index }, year)));
            }),
            React.createElement("div", { className: "btn-container" },
                React.createElement("button", { type: "button", onClick: () => {
                        props.setYearlyDrawer(false);
                        props.setCurrYear(newSelectedYear
                            .slice(5, newSelectedYear.length)
                            .replace("-", ""));
                        props.setFinYear(selectedYear);
                    } }, "Confirm")))));
};
export default CalendarYealryPopupDesk;
